type Props = {
  study: string;
  section: string;
  subSection?: string;
};

export const getPageTitle = ({ study, section, subSection }: Props) =>
  `${study} ${subSection ? ` - ${subSection}` : ''} - ${section} | Askable`;
